import React from 'react'
import Textfield from '@react/react-spectrum/Textfield'

const isValidPrice = v => /^\d{0,8}(\.\d{0,4})?$/g.test(v)

const PriceField = ({ value, defaultValue, onChange, ...otherProps }) => {
  const changeIfValid = v => {
    if (isValidPrice(v)) {
      onChange(v)
    }
  }

  return <Textfield {...otherProps} value={value || ''} onChange={changeIfValid} />
}

export default PriceField
